/*
 * @Author: cc
 * @Date: 2019-12-08 19:24:26
 * @LastEditTime: 2020-03-01 19:55:49
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\service\share\share.js
 * @Description:
 */
'use strict';
angular.module('shareModule', []).controller('shareCtrl', shareCtrl);
shareCtrl.inject = ['$scope', '$timeout', '$modalInstance', 'trsHttpService', 'trsspliceString', 'modalDialog', 'supply', 'editingCenterService'];

/**
 * [shareCtrl description]
 * @param   {[type]}  $scope           [$scope description]
 * @param   {[type]}  $timeout         [$timeout description]
 * @param   {[type]}  $modalInstance   [$modalInstance description]
 * @param   {[type]}  trsHttpService   [trsHttpService description]
 * @param   {[type]}  trsspliceString  [trsspliceString description]
 * @param   {[type]}  modalDialog      [modalDialog description]
 * @param   {[type]}  supply           [supply description]
 * @return  {[type]}                   [return description]
 */
function shareCtrl($scope, $timeout, $modalInstance, trsHttpService, trsspliceString, modalDialog, supply, editingCenterService) {
    init();

    /**
     * [init description]初始化方法
     * @return  {[type]}  [return description]
     */
    function init() {
        // 组织树配置文件
        $scope.treeOptions = editingCenterService.channelTreeOptions();
        var treeParams = {
            serviceid: 'mlf_group',
            methodname: 'queryGroupTreeWithMyPath',
        };
        // 获取没有权限的组织树
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), treeParams, 'get').then(
            function(data) {
                $scope.treedata = [data];
                ExpandedNodes();
            },
            function(data) {
            },
        );
        $scope.itemsSd = [];
        // 初始化稿件分类已选数组
        $scope.mClassSelected = {};
        // 初始化最近记录限制
        $scope.limitRecordNum = 6;
        // 初始化共享范围开始
        $scope.selectedRange = null;
        // 已进入选择栏的用户id
        $scope.selectedUser = [];
        // 初始化统一供稿标识状态；
        $scope.unifiedFeeds = {
            unifiedFeeds: '',
        };
        // 初始化其他共享标识状态
        $scope.otherShare = {
            otherShare: '',
        };
        // 获取稿件分类列表
        getMClassification();
        // 获取共享模板
        getShareTemplate();
        // 获取共享范围
        getRange();
    }

    // 弹窗初始化
    $scope.showSelected = function(node) {
        $timeout(function() {
            // 此判断如果两次点击同一个树，不重复加载角色列表。
            if ($scope.oldSelectNode !== undefined && node.GROUPID == $scope.oldSelectNode.GROUPID) {
                return;
            }
            $scope.groupObj = node;
            $scope.oldSelectNode = node;
            $scope.Datas = [];
            $scope.userData = null;
            $scope.searchDatas = [];
            var params = {
                serviceid: 'mlf_group',
                methodname: 'getUsersByGroup',
                GroupId: $scope.groupObj.GROUPID,
            };
            // trsHttpService.httpServer("./manageConfig/data/roledata_" + $scope.groupObj.id + ".json", params, "get").then(function(data) {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.userDatas = data;
                if (!angular.isDefined(node.CHILDREN) || node.CHILDREN.length === 0) {
                    childrenTree(node, function() {
                        $scope.userDatas = $scope.userDatas.concat(node.CHILDREN);
                    });
                } else {
                    $scope.userDatas = $scope.userDatas.concat(node.CHILDREN);
                }
            });
        }, 100);
    };
    $scope.showToggle = function(node) {
        if ((node.HASCHILDREN === 'true' && !angular.isDefined(node.CHILDREN)) || node.CHILDREN.length === 0) {
            childrenTree(node, function() {
            });
        }
    };

    /**
     * [selectedAll description] 全选
     * @return {[type]} [description] null
     */
    $scope.selectedAll = function() {
        if ($scope.isSearch) {
            angular.forEach($scope.userDatas, function(data, index, array) {
                delete data.selected;
                if (angular.isDefined(data.OBJID)) {
                    data.ID = data.OBJID;
                    data.DESC = data.GNAME;
                    data.OPERTYPE = data.OBJTYPE;
                } else {
                    data.DESC = data.USERNAME;

                    /* if (angular.isUndefined(data.OBJTYPE)) {
                        data.OPERTYPE = data.TYPE;
                    }*/
                }
                $scope.itemsSd = contrast([angular.copy(data)], angular.copy($scope.itemsSd), 'ID', 'OPERTYPE');
                $scope.userDatas[index].selected = false;
                if ($scope.selectedUser.indexOf(data.ID) < 0) {
                    $scope.selectedUser.push(data.ID);
                }
            });
        } else {
            angular.forEach($scope.userDatas, function(data, index, array) {
                delete data.selected;
                if (angular.isDefined(data.OBJID)) {
                    data.ID = data.OBJID;
                    data.DESC = data.GNAME;
                    data.OPERTYPE = data.OBJTYPE;
                } else {
                    data.DESC = data.USERNAME;

                    /* if (angular.isUndefined(data.OBJTYPE)) {
                        data.OPERTYPE = data.TYPE;
                    }*/
                }
                $scope.itemsSd = contrast([angular.copy(data)], angular.copy($scope.itemsSd), 'ID', 'OPERTYPE');
                $scope.userDatas[index].selected = false;
                if ($scope.selectedUser.indexOf(data.ID) < 0) {
                    $scope.selectedUser.push(data.ID);
                }
            });
        }
    };
    $scope.close = function() {
        $modalInstance.dismiss();
    };
    // 输入过滤器
    $scope.myFilter = function(expected, actual) {
        var flag = true;
        if ($scope.searchWordLeft !== '' && angular.isDefined($scope.searchWordLeft)) {
            if (angular.isDefined(expected.USERNAME)) {
                flag = expected.USERNAME.indexOf($scope.searchWordLeft) >= 0;
            } else {
                flag = expected.GNAME.indexOf($scope.searchWordLeft) >= 0;
            }
        }
        return flag;
    };
    // 输入过滤器
    $scope.toRight = function() {
        angular.forEach($scope.userDatas, function(data, index, array) {
            if (angular.isDefined(data.OBJID)) {
                data.ID = data.OBJID;
                data.DESC = data.GNAME;
                data.OPERTYPE = data.OBJTYPE;
            } else {
                data.DESC = data.USERNAME;

                /* if (angular.isUndefined(data.OBJTYPE)) {
                    data.OPERTYPE = data.TYPE;
                }*/
            }
            if (data.selected === true) {
                delete data.selected;
                $scope.itemsSd = contrast([angular.copy(data)], angular.copy($scope.itemsSd), 'ID', 'OPERTYPE');
                $scope.userDatas[index].selected = false;
                $scope.selectedUser.push(data.ID);
            }
        });
    };
    // 双击选择开始
    $scope.directlyToRight = function(user) {
        if (angular.isDefined(user.OBJID)) {
            user.ID = user.OBJID;
            user.DESC = user.GNAME;
            user.OPERTYPE = user.OBJTYPE;
        } else {
            user.DESC = user.USERNAME;
        }
        $scope.selectedUser.push(user.ID);
        $scope.itemsSd = contrast([angular.copy(user)], $scope.itemsSd, 'ID', 'OPERTYPE');
    };
    // 双击选择结束
    // 双击取消选择开始
    $scope.directlyToLeft = function(user) {
        removeList([user], $scope.itemsSd, 'ID', 'OPERTYPE', function(data) {
            $scope.itemsSd = data;
        });
    };
    // 双击取消选择结束
    $scope.toLeft = function() {
        var toRemoveList = [];
        angular.forEach($scope.itemsSd, function(data, index, array) {
            if (angular.isDefined(data.selected) && data.selected === true) {
                toRemoveList.push(data);
                $scope.selectedUser.splice($scope.selectedUser.indexOf(data.ID), 1);
            }
        });
        removeList(toRemoveList, $scope.itemsSd, 'ID', 'OPERTYPE', function(data) {
            $scope.itemsSd = data;
        });
    };
    // 提交共享开始
    $scope.shareSubmit = function() {
        var shareToCats = '';
        angular.forEach($scope.mClassSelected, function(value, key) {
            shareToCats += key + ',';
        });
        var ShareToObjs = [];
        shareToCats = shareToCats.substring(0, shareToCats.length - 1);
        if ($scope.selectedRange === $scope.unifiedFeeds) {
            // 统一供稿处理
            ShareToObjs = '[{}]';
        } else if ($scope.selectedRange === $scope.otherShare) {
            ShareToObjs = packagingShareObj($scope.itemsSd, []).length > 0 ? JSON.stringify(packagingShareObj($scope.itemsSd, [])) : '';
            // ShareToObjs = JSON.stringify(packagingShareObj($scope.itemsSd, []));
        } else if ($scope.selectedRange !== null) {
            var selectedRange = angular.copy($scope.selectedRange);
            selectedRange.OPERIDS = selectedRange.ID;
            delete selectedRange.RANGENAME;
            delete selectedRange.DESC;
            delete selectedRange.ID;
            ShareToObjs = JSON.stringify([selectedRange]);
        } else {
            modalDialog.alertType('请选择共享范围', '', 'info', 'confirm');
            return;
        }
        if (shareToCats === '') {
            modalDialog.alertType('请选择稿件分类', '', 'info', 'confirm');
        } else if (ShareToObjs === '') {
            modalDialog.alertType('', '请选择共享人员', 'error', 'confirm');
        } else {
            $modalInstance.close({
                shareToCats: shareToCats,
                ShareToObjs: ShareToObjs,
            });
        }
    };
    // 提交共享结束
    // 选择分类开始
    $scope.selectMClass = function(item) {
        if (!angular.isDefined($scope.mClassSelected[item.ID])) {
            $scope.mClassSelected[item.ID] = item;
            if ($scope.selectedRange === null) {
                $scope.selectedRange = $scope.unifiedFeeds;
            }
        } else {
            delete $scope.mClassSelected[item.ID];
        }
    };
    // 选择范围
    $scope.selectRange = function(range) {
        if ($scope.selectedRange === range) {
            $scope.selectedRange = null;
        } else {
            $scope.selectedRange = range;
        }
        $scope.$broadcast('modalDialogBroadcast', { range: range });
        $scope.$broadcast('btOpacityBroadcast', { range: range });
    };
    // 选择模板开始
    $scope.selectTemplate = function(item) {
        if (angular.isDefined($scope.selectedTemplate) && $scope.selectedTemplate.SHARETEMPLATEID === item.SHARETEMPLATEID) {
            $scope.selectedTemplate = {};
            $scope.itemsSd = [];
        } else {
            $scope.selectedTemplate = item;
            $scope.selectedRange = $scope.otherShare;
            var params = {
                serviceid: 'mlf_releaseSource',
                methodname: 'getShareObjsByTemplate',
                ShareTemplateId: item.SHARETEMPLATEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.itemsSd = data;
            });
        }
    };
    // 删除常用模板
    $scope.deleteTemplate = function(item, ev) {
        ev.stopPropagation();
        modalDialog.confirmModal('您确定要删除?', '您确定要删除?', function() {
            var params = {
                serviceid: 'mlf_releaseSource',
                methodname: 'delShareTemplate',
                ShareTemplateId: item.SHARETEMPLATEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (!!$scope.selectedTemplate && item.SHARETEMPLATEID == $scope.selectedTemplate.SHARETEMPLATEID) {
                    $scope.selectedTemplate = {};
                }
                getShareTemplate();
            });
        });
    };
    $scope.saveAsTemplate = function() {
        if (angular.isDefined($scope.itemsSd) && $scope.itemsSd.length !== 0) {
            modalDialog.typingModel(
                '分组名称',
                angular.isDefined($scope.selectedTemplate) && $scope.selectedTemplate !== {} ? $scope.selectedTemplate.SHARETEMPLATENAME : '',
                function(data) {
                    var params = {
                        serviceid: 'mlf_releaseSource',
                        methodname: 'saveShareTemplate',
                        ShareTemplateName: data,
                        ShareTemplateId:
                            angular.isDefined($scope.selectedTemplate) && $scope.selectedTemplate !== {}
                                ? parseInt($scope.selectedTemplate.SHARETEMPLATEID)
                                : 0,
                        ShareTemplateValue: JSON.stringify(packagingShareObj($scope.itemsSd, [])),
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType('保存常用模板成功', '', 'success', false, function() {
                            getShareTemplate();
                        });
                    });
                },
            );
        } else {
            modalDialog.alertType('', '请选择部门或人员', 'warning', false, function() {
            });
        }
    };

    /**
     * [getMClassification description] 获取稿件分类
     * @return  {[type]}  [return description]
     */
    function getMClassification() {
        var params = {
            serviceid: 'mlf_sharedoc',
            methodname: 'queryCategorysWithRightOfTouGao',
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            for (var i = 0; i < data.length; i++) {
                if (!data[i].CHILDLIST) {
                    data[i].CHILDLIST = [];
                }
            }
            $scope.mClassification = data;
        });
    }

    /**
     * [getShareTemplate description] 获取共享模板
     * @return  {[type]}  [return description]
     */
    function getShareTemplate() {
        var params = {
            serviceid: 'mlf_releaseSource',
            methodname: 'queryShareTemplates',
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
            $scope.shareTemplateList = data;
        });
    }

    /**
     * [getRange description] 共享范围
     * @return  {[type]}  [return description]
     */
    function getRange() {
        var params = {
            serviceid: 'mlf_releaseSource',
            methodname: 'getShareRange',
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
            $scope.shareRange = data;
        });
    }

    /**
     * [packagingShareObj description] 组装共享对象
     * @param   {[type]}  itemsSd      [itemsSd description]
     * @param   {[type]}  ShareToObjs  [ShareToObjs description]
     * @return  {[type]}               [return description]
     */
    function packagingShareObj(itemsSd, ShareToObjs) {
        angular.forEach(itemsSd, function(data, index, array) {
            var flag = true;
            angular.forEach(ShareToObjs, function(dataC, indexC, arrayC) {
                if (dataC.OPERTYPE !== undefined && dataC.OPERTYPE === data.OPERTYPE) {
                    flag = false;
                }
            });
            if (flag) {
                ShareToObjs.push({
                    OPERTYPE: data.OPERTYPE,
                    OPERIDS: trsspliceString.spliceString(itemsSd, 'ID', ',', 'OPERTYPE', data.OPERTYPE),
                });
            }
        });
        return ShareToObjs;
    }

    /**
     * [childrenTree description] 获取子树
     * @param   {[type]}  node      [node description]
     * @param   {[type]}  callback  [callback description]
     * @return  {[type]}            [return description]
     */
    function childrenTree(node, callback) {
        var paramsT = {
            serviceid: 'mlf_group',
            methodname: 'queryChildGroupsWithOutRight',
            GroupId: node.GROUPID,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paramsT, 'get').then(function(dataC) {
            node.CHILDREN = dataC.CHILDREN;
            if (angular.isFunction(callback)) {
                callback();
            }
        });
    }

    /**
     * [contrast description] 对比是否重复
     * @param   {[type]}  array1      [array1 description]
     * @param   {[type]}  array2      [array2 description]
     * @param   {[type]}  attribute   [attribute description]
     * @param   {[type]}  _attribute  [_attribute description]
     * @return  {[type]}              [return description]
     */
    function contrast(array1, array2, attribute, _attribute) {
        angular.forEach(array1, function(data, index, array) {
            var flag = true;
            angular.forEach(array2, function(_data, _index, _array) {
                if (data[attribute] === _data[attribute] && data[_attribute] === _data[_attribute]) {
                    flag = false;
                }
            });
            if (flag) {
                array2.push(data);
            }
        });
        return array2;
    }

    /**
     * [removeList description]
     * @param   {[type]}  array1      [array1 description]
     * @param   {[type]}  array2      [array2 description]
     * @param   {[type]}  attribute   [attribute description]
     * @param   {[type]}  _attribute  [_attribute description]
     * @param   {[type]}  success     [success description]
     * @return  {[type]}              [return description]
     */
    function removeList(array1, array2, attribute, _attribute, success) {
        angular.forEach(array1, function(data) {
            var i = 0;
            while (i < array2.length) {
                if (data[attribute] === array2[i][attribute] && data[_attribute] === array2[i][_attribute]) {
                    array2.splice(i, 1);
                } else {
                    i++;
                }
            }
        });
        success(array2);
    }

    /**
     * [ExpandedNodes description] 展开树节点
     * @return  {[type]}  [return description]
     */
    function ExpandedNodes() {
        $scope.expandedTest = [];
        var flag = true;
        angular.forEach($scope.treedata[0].CHILDREN, function(data, index, array) {
            if (data.ISPATH === 'true') {
                flag = false;
                if (angular.isDefined(data.CHILDREN) && data.CHILDREN.length !== 0) {
                    $scope.expandedTest.push(data);
                    selfPath(data);
                } else {
                    $scope.selectedNode = data;
                    getGroupData($scope.selectedNode);
                }
            }
        });
        if (flag) {
            $scope.selectedNode = $scope.treedata[0];
            getGroupData($scope.selectedNode);
        } else {
            $scope.expandedTest.push($scope.treedata[0]);
        }
    }

    /**
     * [getGroupData description] 获取分组信息
     * @param   {[type]}  node  [node description]
     * @return  {[type]}        [return description]
     */
    function getGroupData(node) {
        $timeout(function() {
            $scope.groupObj = node;
            var params = {
                serviceid: 'mlf_group',
                methodname: 'getUsersByGroup',
                GroupId: $scope.groupObj.GROUPID,
            };
            // trsHttpService.httpServer("./manageConfig/data/roledata_" + $scope.groupObj.id + ".json", params, "get").then(function(data) {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.userDatas = data;
                if (!angular.isDefined($scope.selectedNode.CHILDREN) || $scope.selectedNode.CHILDREN.length === 0) {
                    childrenTree($scope.selectedNode, function() {
                        $scope.userDatas = $scope.userDatas.concat($scope.selectedNode.CHILDREN);
                    });
                } else {
                    $scope.userDatas = $scope.userDatas.concat($scope.selectedNode.CHILDREN);
                }
            });
        }, 100);
    }

    /**
     * [selfPath description]
     * @param   {[type]}  data  [data description]
     * @return  {[type]}        [return description]
     */
    function selfPath(data) {
        for (var i = 0; i < data.CHILDREN.length; i++) {
            if (data.CHILDREN[i].ISPATH === 'true') {
                if (data.CHILDREN[i].HASCHILDREN === 'false' || data.CHILDREN[i].CHILDREN.length === 0) {
                    $scope.selectedNode = data.CHILDREN[i];
                    getGroupData($scope.selectedNode);
                } else {
                    $scope.expandedTest.push(data.CHILDREN[i]);
                    selfPath(data.CHILDREN[i]);
                }
            }
        }
    }

    $scope.getSuggestions = function(viewValue) {
        var searchUsers = {
            serviceid: 'mlf_extuser',
            methodname: 'searchUserOrDept',
            Name: viewValue,
        };
        if (viewValue !== '') {
            if ($scope.isRequest) {
                $scope.isRequest = false;
                return [];
            } else {
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchUsers, 'post').then(function(data) {
                    return data;
                });
            }
        }
    };
    $scope.$watch('searchWord', function(newValue, oldValue, scope) {
        if (angular.isObject(newValue)) {
            var flag = true;
            angular.forEach($scope.itemsSd, function(data, index, array) {
                if (data.ID === newValue.ID) {
                    flag = false;
                }
            });
            if (flag) {
                $scope.isRequest = true;
                newValue.OPERTYPE = newValue.TYPE;
                newValue.DESC = newValue.GNAME || newValue.USERNAME;
                $scope.itemsSd.push(newValue);
            }
            $scope.searchWord = newValue.USERNAME || newValue.GNAME;
        }
    });

    // 监听搜索框
    $scope.$watch('searchWordLeft', function(newValue, oldValue, scope) {
        if (newValue === '') {
            $scope.isSearch = false;
        }
        $scope.searchDatas = [];
        if ($scope.searchWordLeft !== '' && angular.isDefined($scope.searchWordLeft)) {
            for (var i = 0; i < $scope.userDatas.length; i++) {
                if ($scope.userDatas[i].USERNAME.indexOf($scope.searchWordLeft) !== -1) {
                    $scope.isSearch = true;
                    $scope.searchDatas.push($scope.userDatas[i]);
                }
            }
        }
    });
}
